import axios from './axios';

const getPatient = (params) => {
  return axios.post('/onlineDrug/recipe/getPatient', params);
};

// 协议信息 0:隐私政策 1:用户协议
const getProtocol = (params) => {
  return axios.post('/onlineDrug/getuUserAgreementOrPrivacyPolicy', params);
};

export default {
  getPatient,
  getProtocol,
};
